module.exports = __webpack_public_path__ + "img/snoskredaktsomhet.5d91062d.jpg";